// src/components/dashboard/contexts/DashboardContext.js
import { createContext } from 'react';

// Create the Dashboard context
const DashboardContext = createContext();

export default DashboardContext;